<template>
    <main class="page">
        <!-- Banner -->
        <!-- <section v-if="main" class="section--banner" v-lazy:background-image.container="{
                src: env.imageUrl + main.banner.home_banner.image,
                loading: env.imageUrl + main.banner.home_banner.thumb_image,
            }">
            <div class="motor-banner">
                <h1>{{main.banner.home_banner.title}}</h1>
                <p>{{main.banner.home_banner.subtitle}}</p>
            </div>
        </section> -->
        <home-banner :slides="slides" />
        <!-- Section -->
        <section class="section--or" v-if="home">
            <article class="article article--start">
                <div class="motor-or">or</div>
                <h1>{{home.quick[0].title}}</h1>
                <p>{{home.quick[0].description}}</p>
                <router-link v-if="home.quick[0].link === 'showroom'" to="/wedo/showroom/0" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[0].link === 'workshop'" to="/wedo/workshop" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[0].link === 'training'" to="/wedo/training" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[0].link === 'production'" to="/wedo/production/0" class="button--motor">read more</router-link>
            </article>
            <article class="article article--end">
                <h1>{{home.quick[1].title}}</h1>
                <p>{{home.quick[1].description}}</p>
                <router-link v-if="home.quick[1].link === 'showroom'" to="/wedo/showroom/0" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[1].link === 'workshop'" to="/wedo/workshop" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[1].link === 'training'" to="/wedo/training" class="button--motor">read more</router-link>
                <router-link v-if="home.quick[1].link === 'production'" to="/wedo/production/0" class="button--motor">read more</router-link>
            </article>
        </section>
        <!-- Section -->
        <section class="section section--about" v-if="home">
            <h1>about us</h1>
            <h2>{{home.about_home.title}}</h2>
            <div class="motor-container">
                <p v-html="home.about_home.description"></p>
                <router-link to="/about" class="button--motor">read more</router-link>
            </div>
        </section>
        <!-- Section -->
        <section class="section section--wedo" v-if="home">
            <h1>what we do</h1>
            <h2>{{home.wedo_news.wedo_title}}</h2>
            <div class="motor-container">
                <article class="wedo-section media article1" v-lazy:background-image.container="{
                    src: env.imageUrl + home.wedo[0].image,
                    loading: env.imageUrl + home.wedo[0].thumb_image,
                }"></article>
                <article class="wedo-section description article2">
                    <h2>{{home.wedo[0].title}}</h2>
                    <p>{{home.wedo[0].description}}</p>
                </article>

                <article class="wedo-section media article3" v-lazy:background-image.container="{
                    src: env.imageUrl + home.wedo[1].image,
                    loading: env.imageUrl + home.wedo[1].thumb_image,
                }"></article>
                <article class="wedo-section description article4">
                    <h2>{{home.wedo[1].title}}</h2>
                    <p>{{home.wedo[1].description}}</p>
                </article>

                <article class="wedo-section media article5" v-lazy:background-image.container="{
                    src: env.imageUrl + home.wedo[2].image,
                    loading: env.imageUrl + home.wedo[2].thumb_image,
                }"></article>
                <article class="wedo-section description article6">
                    <h2>{{home.wedo[2].title}}</h2>
                    <p>{{home.wedo[2].description}}</p>
                </article>

                <article class="wedo-section media article7" v-lazy:background-image.container="{
                    src: env.imageUrl + home.wedo[3].image,
                    loading: env.imageUrl + home.wedo[3].thumb_image,
                }"></article>
                <article class="wedo-section description article8">
                    <h2>{{home.wedo[3].title}}</h2>
                    <p>{{home.wedo[3].description}}</p>
                </article>
            </div>
        </section>
        <!-- Section -->
        <section class="section section--news" v-if="home">
            <h1>Latest news</h1>
            <h2>{{home.wedo_news.news_title}}</h2>
            <div class="motor-container">
                <router-link :to="'/news/' + news.id" class="article" v-for="news in home.news" :key="news.id">
                    <div class="wrapper">
                        <img v-lazy="{
                            src: env.imageUrl + news.image,
                            loading: env.imageUrl + news.thumb_image,
                        }" alt="media">
                    </div>
                    <h3>{{news.title}}</h3>
                    <div class="info">
                        <div class="txt author">{{news.user.name}}</div>
                        <div class="devider"></div>
                        <div class="txt category">{{news.newscategory.name}}</div>
                        <div class="devider"></div>
                        <div class="txt date">{{news.date | formatDate}}</div>
                    </div>
                    <p>{{news.short_text}}</p>
                </router-link>
            </div>
        </section>
        <!-- Footer -->
        <motor-footer :data="main" />
    </main>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import { env } from '../enviorments'
import HomeBanner from '@/components/HomeBanner'

export default {
    name: 'home',
    components: {
        HomeBanner,
    },
    data() {
        return {
            env,
        }
    },
    computed: {
        ...mapState({
            main: state => state.main,
            home: state => state.home,
            slides: state => state.slides
        })
    },
    methods: {
        ...mapActions({
            callMain: 'callMain',
            callHome: 'callHome',
            callSlides: 'callSlides',
        })
    },
    async mounted() {
        if (!this.slides.length) this.callSlides()
        if (!this.main) await this.callMain()
        if (!this.home) await this.callHome()
        console.log(this.main, this.home)
    }
}
</script>

<style lang="scss" scoped>
.page {
    .section--banner {
        width: 100%;
        height: 800px;
        max-height: 100vh;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        padding-top: var(--header-height);
        .motor-banner {
            width: 100%;
            max-width: 1500px;
            padding: 40px 10px;
            text-align: center;
            font-size: 2rem;
            background-image: linear-gradient(to right, #2e79bcdd, #2e79bcdd);
            @media (min-width: 576px) {
                font-size: 2rem;
            }
            @media (min-width: 768px) {
                font-size: 2.5rem;
                background-image: linear-gradient(to right, #2e79bc00, #2e79bcee, #2e79bcee, #2e79bc00);
            }
            @media (min-width: 992px) {
                font-size: 3rem;
            }
            h1, p {
                margin: 0;
                padding: 5px;
                font-weight: 900;
                color: #fff;
                text-transform: uppercase;
                text-shadow: 0 2px 2px #333;
            }
            h1 {
                font-size: 1.5em;
                line-height: 1.2em;
            }
            p {
                font-size: 1em;
                line-height: 1em;
            }
        }
    }
    .section--or {
        display: flex;
        flex-wrap: wrap;
        .article {
            width: 100%;
            padding: 40px 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #fff;
            @media (min-width: 992px) {
                width: 50%;
            }
            h1 {
                text-align: center;
                color: #fff;
                font-size: 1.5rem;
                font-weight: 300;
            }
            p {
                text-align: center;
                color: #fff;
                max-width: 500px;
            }
            .button--motor {
                margin-top: 20px;
            }
            &.article--start {
                background-image: linear-gradient(to bottom, var(--primary), var(--secondary));
                position: relative;
                @media (min-width: 992px) {
                    background-image: linear-gradient(to right, var(--primary), var(--secondary));
                    align-items: flex-end;
                    padding-right: 60px;
                    h1, p {
                        text-align: right;
                    }
                }
                .motor-or {
                    position: absolute;
                    z-index: 1;
                    bottom: 0;
                    right: 50%;
                    transform: translate(50%, 50%);
                    width: 60px;
                    height: 60px;
                    background-color: #fff;
                    border: 5px solid var(--secondary);
                    border-radius: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #111;
                    text-transform: uppercase;
                    box-shadow: 0 2px 5px #3339, inset 0 1px 2px #3339;
                    @media (min-width: 992px) {
                        bottom: 50%;
                        right: 0;
                    }
                }
            }
            &.article--end {
                background-color: var(--primary);
                @media (min-width: 992px) {
                    align-items: flex-start;
                    padding-left: 60px;
                    h1, p {
                        text-align: left;
                    }
                }
            }
        }
    }
    .section {
        padding: 60px 0;
        h1 {
            font-size: 2rem;
            text-transform: uppercase;
            font-weight: 300;
            text-align: center;
            margin: 0 auto;
            color: var(--primary);
            @media (min-width: 992px) {
                font-size: 4rem;
            }
        }
        h2 {
            font-weight: 300;
            text-align: center;
            @media (min-width: 992px) {
                font-size: 2rem;
            }
        }
    }
    .section--about {
        .motor-container {
            max-width: 800px;
            p {
                text-align: center;
            }
            .button--motor {
                margin: 20px auto;
            }
        }
    }
    .section--wedo {
        background-color: var(--theme-bg);
        .motor-container {
            display: flex;
            flex-wrap: wrap;
            margin: 40px auto;
            .wedo-section {
                width: 100%;
                height: initial;
            }
            .media {
                height: 200px;
                background-color: #f4f4f4;
                background-image: url(../assets/images/home-banner.jpg);
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center;
                @media (min-width: 768px) {
                    height: initial;
                }
            }
            .description {
                padding: 30px 10px;
                background-color: var(--primary);
                h2, p {
                    color: #fff;
                    text-align: center;
                    padding: 10px;
                }
            }
            @media (min-width: 768px) {
                .wedo-section {
                    width: 50%;
                }
                .article1 {order: 2}
                .article2 {order: 1}
                .article3 {order: 3}
                .article4 {order: 4}
                .article5 {order: 6}
                .article6 {order: 5}
                .article7 {order: 7}
                .article8 {order: 8}
            }
            @media (min-width: 992px) {
                .wedo-section {
                    width: 25%;
                }
                .article3 {order: 4}
                .article4 {order: 3}
                .article5 {order: 5}
                .article6 {order: 6}
            }
        }
    }
}
</style>

